import React from 'react';
import {
  FileText,
  Users,
  FolderOpen,
  CheckSquare,
  MessageSquare,
  Calendar,
  Briefcase,
  User
} from 'lucide-react';

const CaseContextSummary = ({ context, onRefresh }) => {
  if (!context) return null;

  const contextItems = [
    {
      icon: Briefcase,
      label: 'Case Type',
      value: context.case_type || 'Not specified',
    },
    {
      icon: User,
      label: 'Client',
      value: context.client_name || 'Not specified',
    },
    {
      icon: Users,
      label: 'Team Members',
      value: context.team_members,
      isCount: true,
    },
    {
      icon: FolderOpen,
      label: 'Projects',
      value: context.projects,
      isCount: true,
    },
    {
      icon: CheckSquare,
      label: 'Tasks',
      value: context.tasks,
      isCount: true,
    },
    {
      icon: FileText,
      label: 'Documents',
      value: context.documents,
      isCount: true,
    },
    {
      icon: MessageSquare,
      label: 'Communications',
      value: context.recent_communications,
      isCount: true,
    },
    {
      icon: Calendar,
      label: 'Upcoming Events',
      value: context.upcoming_events,
      isCount: true,
    },
  ];

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-medium text-gray-900">
          AI has access to case information
        </h3>
        <button
          onClick={onRefresh}
          className="text-xs text-yellow-600 hover:text-gray-800 underline"
        >
          Refresh context
        </button>
      </div>

      <div className="grid grid-cols-2 gap-3 text-xs">
        {contextItems.map((item, index) => (
          <div key={index} className="flex items-center gap-2">
            <item.icon size={14} className="text-yellow-600 flex-shrink-0" />
            <span className="text-gray-600">{item.label}:</span>
            <span className="font-medium text-gray-900">
              {item.isCount ? (
                <span className="bg-gray-100 text-gray-800 px-1.5 py-0.5 rounded">
                  {item.value}
                </span>
              ) : (
                item.value
              )}
            </span>
          </div>
        ))}
      </div>

      <div className="mt-3 text-xs text-yellow-600">
        The AI can answer questions about case details, documents, tasks, communications,
        team members, and upcoming events.
      </div>
    </div>
  );
};

export default CaseContextSummary;